package de.katoonerie.lib

import de.katoonerie.util.await
import kotlin.js.Promise
import org.w3c.dom.url.URL

external class TransformStream {
    val readable: dynamic
    val writable: dynamic
}

external class Response(readable: dynamic) {
    fun text(): Promise<dynamic>
}

suspend fun getFirstEntryText(url: URL): String {
    val httpReader = zip.HttpReader(url.toString())
    val transformStream = TransformStream()
    val responseText = Response(transformStream.readable).text()

    val zipReader = zip.ZipReader(httpReader)
    val firstEntry = zipReader.getEntries().await().first()
    firstEntry.getData(transformStream.writable).await()
    zipReader.close().await()

    val text = responseText.await()
    return text.toString()
}
